import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import { dateFormate, utcTimeToLocal } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { ListCategories } from "../../actions/categoryAction";
import { dateFormatting } from "../utils/Utils";
import { Modal, Button, Form, Spinner, ListGroup } from "react-bootstrap";
import imageCompression from "browser-image-compression";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import RentOutModal from "./RentOutModal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { formatDate } from "../utils/Utils";
import EditViewStockModal from "./EditModal";

export default function Product() {
  const [stockItem, setStockItem] = useState(null);
  useEffect(() => {
    fetchStockItem();
  }, []);

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const catList = useSelector((state) => state.catList);
  const { loading, error, categories } = catList;

  // const [logs, setLogs] = useState([]);
  const [product, setProduct] = useState();
  console.log(product);
  const [brandList, setBrandList] = useState([]);

  const [orderList, setOrderList] = useState([]);
  console.log(orderList);
  const [report, setReport] = useState(null);
  console.log(report, "report");
  console.log(product, "product");

  useEffect(() => {
    getProduct();
  }, []);
  useEffect(() => {
    if (!product) return;
    setLogPage(1);
    setHasMoreLogs(true);
    getLogs(1);

    getBrands();
    dispatch(ListCategories(""));
    getOrder();
    handleItemcode();
  }, [product]);

  const [selectedStock, setSelectedStock] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [loadings, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    photo1: null,
    photo2: null,
    billUpload: null,
    purchaseCost: "",
    purchaseDate: "",
    warranty: "",
    warrantyExpiryDate: "",
    services: [],
  });

  const fileInput1 = useRef(null);
  const fileInput2 = useRef(null);
  const fileInput3 = useRef(null);

  const [itemCodeResponses, setItemCodeResponses] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItemData, setSelectedItemData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [logs, setLogs] = useState([]);
  const [logPage, setLogPage] = useState(1);
  const [hasMoreLogs, setHasMoreLogs] = useState(true);
  const [logsLoading, setLogsLoading] = useState(false);

  console.log(itemCodeResponses);

  const openModal = (itemCode, orderId, _id) => {
    setSelectedItemData({ itemCode, orderId, _id });
    setIsModalOpen(true);
  };

  // Close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedItemData(null);
  };

  const openEditModal = (stock) => {
    // navigate(`/stock/edit/${stock.itemCode}`);

    setSelectedStock(stock);
    setFormData({
      photo1: null,
      photo2: null,
      billUpload: null,
      purchaseCost: stock.purchaseCost || "",
      warranty: stock.warranty || "",
      purchaseDate: formatDate(stock.purchaseDate),
      warrantyExpiryDate: formatDate(stock.warrantyExpiryDate),
    });
    setIsEditModalOpen(true);
  };

  const openViewModal = (stock) => {
    fetchStockItem();
    setSelectedStock(stock);
    console.log(stock);
    setIsViewModalOpen(true);
  };

  const handleItemcode = async () => {
    if (!product?.stock) return;

    try {
      const responses = await Promise.all(
        product.stock.map(async (stockItem) => {
          const itemCode = String(stockItem.itemCode).trim();

          try {
            const res = await Axios.post("/api/products/itemcode/details", {
              itemCode,
            });

            return res.data; // ✅ return data
          } catch (error) {
            console.error("Failed itemCode:", itemCode);
            return null; // ✅ prevent crash
          }
        }),
      );

      setItemCodeResponses(responses.filter(Boolean)); // ✅ set once
    } catch (error) {
      console.error("Error fetching item codes:", error);
    }
  };
  const handleClose = () => {
    setIsEditModalOpen(false);
    setIsViewModalOpen(false);
    // navigate(`/stock/edit/${stock.itemCode}`);

    setSelectedStock(null);
    // Clear file inputs
    if (fileInput1.current) fileInput1.current.value = "";
    if (fileInput2.current) fileInput2.current.value = "";
  };

  const handleFileChange = async (
    e,
    fieldName,
    index = null,
    isService = false,
  ) => {
    const file = e.target.files[0];
    if (!file) return;

    // Image compression options
    const options = {
      maxSizeMB: 0.2, // Compress to 1MB or less
      maxWidthOrHeight: 1024, // Max width or height
      useWebWorker: true, // Use a web worker for processing
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      const uploadFormData = new FormData();
      uploadFormData.append("image", compressedFile);

      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Upload the file
      const { data } = await Axios.post("/api/upload", uploadFormData, config);

      // Set the uploaded file data based on the field

      if (isService && index !== null) {
        // Update photo in services array
        setFormData((prevState) => {
          const updatedServices = [...(prevState.services || [])];
          updatedServices[index] = {
            ...updatedServices[index],
            photo: data,
          };
          return { ...prevState, services: updatedServices };
        });
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [fieldName]: data, // Assuming `fileUrl` is returned from your API
        }));
      }

      setUploading(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploading(false);
    }
  };

  const fetchStockItem = async () => {
    try {
      const { data } = await Axios.get(
        `/api/${product._id}/stock/${selectedStock.itemCode}`,
      );
      setStockItem(data);
      console.log(data, "datsssssssssssss");
    } catch (error) {
    } finally {
    }
  };

  console.log(formData, "formDataaaaaaaaaaaaaaaaaaaaaaaaa");

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Check if product._id and selectedStock.itemCode are defined
    if (!product?._id || !selectedStock?.itemCode) {
      console.error("Product ID or Stock Item Code is missing");
      return;
    }

    try {
      const response = await Axios.put(
        `/api/products/${product._id}/stock/${selectedStock.itemCode}`,
        {
          photo1: formData.photo1,
          photo2: formData.photo2,
          billUpload: formData.billUpload,
          purchaseCost: formData.purchaseCost,
          purchaseDate: formData.purchaseDate,
          warranty: formData.warranty,
          warrantyExpiryDate: formData.warrantyExpiryDate,
          services: formData.services || [],
        },
      );
      // await new Promise(resolve => setTimeout(resolve, 2000));
      // window.location.reload();

      console.log("Stock item updated successfully:", response.data);
      handleClose();
    } catch (error) {
      console.error(
        "Error updating stock item:",
        error.response?.data || error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getProduct = async () => {
    try {
      setPageLoading(true);

      const { data } = await Axios.get(`/api/products/${id}`);
      const res = await Axios.get(`/api/products/report/${id}`);

      setReport(res?.data?.obj);
      setProduct(data);
    } catch (error) {
      console.error(error);
    } finally {
      setPageLoading(false);
    }
  };
  const getLogs = async (page = 1) => {
    try {
      setLogsLoading(true);

      const { data } = await Axios.post(`/api/log`, {
        product: id,
        page,
        limit: 10,
      });

      const newLogs = data?.data || [];

      if (page === 1) {
        setLogs(newLogs);
      } else {
        setLogs((prev) => [...prev, ...newLogs]);
      }

      // check if more pages exist
      if (page >= data.pages) {
        setHasMoreLogs(false);
      }
    } catch (error) {
      console.error("Error loading logs:", error);
    } finally {
      setLogsLoading(false);
    }
  };

  const getBrands = async () => {
    let data = await Axios.get(`/api/brand/`);
    setBrandList(data.data.brands);
  };

  const getBrandName = (id) => {
    let brand = brandList.find((data) => data._id === id);

    return brand?.brandName;
  };
  const getProductCategory = (id) => {
    let cat = categories.find((data) => data._id === id);

    return cat?.categoryName;
  };

  const getOrder = async (stock) => {
    let data = await Axios.get(`/api/order/item/order-items`);
    console.log(data);
    setOrderList(data);
    //  return 'as';
  };

  const checkStock = (stock) => {
    const stockItem = product?.stock?.find((s) => s.itemCode === stock);

    if (stockItem?.isService) {
      return "Service";
    }

    if (!orderList?.data?.data) return "-";

    for (const order of orderList.data.data) {
      for (const item of order.orderItems) {
        if (item.stock === stock) {
          if (item.isRentOut) return "Rent Out";
          if (!item.isRentOut && !item.isReturn) return "Ordered";
        }
      }
    }

    return "Available";
  };

  const toggleService = async (itemCode) => {
    try {
      await Axios.put(`/api/products/${product._id}/service/${itemCode}`);

      getProduct();
    } catch (error) {
      console.error(error);
    }
  };

  const serviceCount = product?.stock?.filter((s) => s?.isService)?.length || 0;

  const filteredLogs = logs?.filter((log) => {
    const userName = (log.user?.name || "").toString().toLowerCase();
    const orderId = (log.order?.orderId || "").toString().toLowerCase();
    const term = searchTerm.toLowerCase();

    return userName.includes(term) || orderId.includes(term);
  });

  if (pageLoading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }
  return (
    <div className="row">
      <div class="col-md-6 stretch-card grid-margin">
        {" "}
        <div class="card">
          <div class="card-body" style={{ height: "100vh", overflowY: "auto" }}>
            {" "}
            <div class="d-flex">
              <div class="mr-auto p-2">
                {" "}
                <p class="card-title">Basic Details</p>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-4">Product Name</div>
              <div className="col-8">
                <b>{product?.name}</b>
              </div>
            </div>
            <div className="row  p-3">
              <div className="col-4">Product Category</div>
              <div className="col-8">
                <b>{getProductCategory(product?.category?._id)}</b>
              </div>
            </div>
            <div className="row  p-3">
              <div className="col-4">Product Brand</div>
              <div className="col-8">
                <b>{getBrandName(product?.brand?._id)}</b>
              </div>
            </div>
            <div className="row  p-3">
              <div className="col-4">Price</div>
              <div className="col-8">
                <b>{product?.price}</b>
              </div>
            </div>
            <div className="row  p-3">
              <div className="col-4">Offer price</div>
              <div className="col-8">
                <b>{product?.offerPrice}</b>
              </div>
            </div>
            <div className="row  p-3">
              <div className="col-4">Product Type</div>
              <div className="col-8">
                <b>{product?.productType ? "Yes" : "No"}</b>
              </div>
            </div>
            <hr />
            <div class="d-flex">
              <div class="mr-auto p-2">
                {" "}
                <p class="card-title">Report</p>
              </div>
            </div>
            <div className="row ml-5">
              <div className="col-4 p-1">Total Stock</div>
              <div className="col-6  p-1">
                <b>{product?.stock?.length}</b>
              </div>
            </div>
            <div className="row ml-5">
              <div className="col-4 p-1">Ordered</div>
              <div className="col-6 p-1">
                <b>{report?.ordered || 0}</b>
              </div>
            </div>
            <div className="row ml-5">
              <div className="col-4 p-1">Rent Out</div>
              <div className="col-6  p-1">
                <b>{report?.rentOut}</b>
              </div>
            </div>
            <div className="row ml-5">
              <div className="col-4 p-1">Service</div>
              <div className="col-6 p-1">
                <b>{serviceCount}</b>
              </div>
            </div>
            <div className="row ml-5">
              <div className="col-4 p-1">Available</div>
              <div className="col-6 p-1">
                <b>
                  {(product?.stock?.length || 0) -
                    (report?.rentOut || 0) -
                    serviceCount}
                </b>
              </div>
            </div>
            <hr />
            <div class="d-flex">
              <div class="mr-auto p-2">
                {" "}
                <p class="card-title">Stocks</p>
              </div>
            </div>
            {product?.stock?.map((data, index) => {
              return (
                <div key={index}>
                  <b> {index + 1} .</b>
                  <div className="row ml-5">
                    <div className="col-4 p-1">Item Code</div>

                    <div className="col-6 p-1">
                      <b>{data?.itemCode}</b>
                    </div>

                    <div className="col-2 p-1" style={{ fontSize: "12px" }}>
                      <span
                        className={`badge ${
                          checkStock(data?.itemCode) === "Service"
                            ? "badge-danger"
                            : checkStock(data?.itemCode) === "Rent Out"
                              ? "badge-info"
                              : checkStock(data?.itemCode) === "Ordered"
                                ? "badge-secondary"
                                : "badge-warning"
                        }`}
                      >
                        {" "}
                        {checkStock(data?.itemCode)}
                        {itemCodeResponses.map((items, idx) =>
                          items?.map((item) =>
                            item?.orderId &&
                            checkStock(data?.itemCode) === "Rent Out" ? (
                              <span
                                key={item._id}
                                style={{ color: "black", cursor: "pointer" }}
                                onClick={() =>
                                  openModal(
                                    data?.itemCode,
                                    item?.orderId,
                                    item?._id,
                                  )
                                }
                              >
                                <i className="fa-solid fa-eye"></i>
                              </span>
                            ) : null,
                          ),
                        )}
                      </span>
                    </div>

                    <div className="d-flex justify-content-end mx-auto"></div>
                    <div className="col-4 p-1">Serial Number</div>
                    <div className="col-8 p-1">
                      <b>{data?.serialNumber}</b>
                    </div>
                    {/* <div className="col-12 p-1 mt-2">
                      <button
                        className="btn btn-primary mr-2"
                        onClick={() => openEditModal(data)}
                      >
                        <Link to={`/item/${data.itemCode}`}>
                          <i className="fas fa-edit"></i> Update Stock
                        </Link>
                      </button>
                     
                    </div> */}
                    <div className="col-12 p-1 mt-2 d-flex gap-2">
                      <Link
                        to={`/item/${data?.itemCode}`}
                        className="btn btn-outline-primary btn-sm px-2 py-1 mr-2"
                      >
                        <i className="fas fa-edit me-1"></i>
                        Update Stock
                      </Link>

                      <button
                        className={`btn btn-sm ${
                          data?.isService
                            ? "btn-warning"
                            : "btn-outline-warning"
                        }`}
                        onClick={() => toggleService(data?.itemCode)}
                      >
                        {data?.isService ? "Remove Service" : "Service Mode"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
            {/* RentOut Modal */}
            <RentOutModal
              isOpen={isModalOpen}
              closeModal={closeModal}
              itemData={selectedItemData}
            />
            {selectedStock && (
              <EditViewStockModal
                product={product?._id}
                isModalOpen={isEditModalOpen}
                handleClose={() => setIsEditModalOpen(false)}
                handleUpdate={handleUpdate}
                handleFileChange={handleFileChange}
                formData={formData}
                setFormData={setFormData}
                selectedStock={selectedStock}
                loading={loading}
                loadings={loadings}
                fileInput1={fileInput1}
                fileInput2={fileInput2}
                fileInput3={fileInput3}
              />
            )}
          </div>
        </div>
      </div>
      <div className="col-md-6 stretch-card grid-margin">
        <div className="card">
          <div className="card-body">
            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="card-title mb-0">Logs</p>

              <input
                type="text"
                className="form-control"
                style={{ maxWidth: "250px" }}
                placeholder="Search logs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* LOG LIST */}
            <div
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                paddingRight: "5px",
              }}
            >
              {/* 🔥 LOADING (FIRST LOAD) */}
              {logsLoading && logs.length === 0 && (
                <Skeleton count={5} height={70} />
              )}

              {/* 🔥 NO DATA */}
              {!logsLoading && filteredLogs.length === 0 && (
                <p style={{ textAlign: "center", color: "gray" }}>
                  No logs found
                </p>
              )}

              {/* 🔥 LOG ITEMS */}
              {filteredLogs.map((log) => (
                <div
                  key={log._id}
                  className="d-flex align-items-start p-2 mb-2 border rounded"
                  style={{ background: "#f9f9f9" }}
                >
                  {/* USER IMAGE */}
                  <img
                    src={log.user?.photo || "/images/default-user.png"}
                    alt="user"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      marginRight: "10px",
                    }}
                  />

                  {/* DETAILS */}
                  <div>
                    <div>
                      <b>{log.user?.name}</b>
                    </div>

                    <div style={{ fontSize: "0.9rem", color: "#666" }}>
                      {log.user?.address1}
                    </div>

                    <div>
                      {log.action}
                      {log.action === "ORDER PLACED" &&
                        log.startDate &&
                        log.endDate && (
                          <span>
                            {" "}
                            FOR <b>{dateFormatting(log.startDate)}</b> TO{" "}
                            <b>{dateFormatting(log.endDate)}</b>
                          </span>
                        )}
                    </div>

                    <div style={{ fontSize: "0.8rem", color: "#999" }}>
                      {dateFormatting(log.createdAt)}
                      {log.order?.orderId && (
                        <span>
                          {" "}
                          | Order: <b>{log.order.orderId}</b>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* 🔥 VIEW MORE BUTTON */}
            <div className="text-center mt-3">
              {logsLoading && logs.length > 0 && (
                <Spinner animation="border" size="sm" />
              )}

              {hasMoreLogs && !logsLoading && (
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => {
                    const nextPage = logPage + 1;
                    setLogPage(nextPage);
                    getLogs(nextPage);
                  }}
                >
                  View More
                </button>
              )}

              {!hasMoreLogs && logs.length > 0 && (
                <p style={{ color: "gray" }}>No more logs</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
